import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Laura M.',
    age: '42 años',
    text: 'Pensaba que me estaba volviendo loca. En 3 semanas la niebla mental desapareció y he vuelto a dormir 7 horas seguidas. Mi marido dice que he vuelto a ser yo.',
    role: 'Abogada'
  }, {
    name: 'Carmen R.',
    age: '45 años',
    text: 'Había probado ayuno, keto, todo. Nada funcionaba. Con este protocolo no he pasado hambre y me he desinflamado muchísimo. Los pantalones me vuelven a cerrar.',
    role: 'Profesora'
  }, {
    name: 'Patricia S.',
    age: '39 años',
    text: 'Lo compré por la fatiga y me llevé la sorpresa de que mi piel ha mejorado increíblemente. Es sencillo de seguir y muy lógico. Ojalá lo hubiera encontrado antes.',
    role: 'Diseñadora'
  }];
  return <section className="py-20 bg-white" data-id="element-145">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
        <div className="text-center mb-16" data-id="element-147">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-148">
            Ellas ya han recuperado su vitalidad
          </h2>
          <p className="font-sans text-brand-warm-gray" data-id="element-149">
            Mujeres reales. Resultados reales. Sin pastillas ni dietas extremas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-150">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-brand-cream p-8 rounded-xl relative hover:-translate-y-2 transition-transform duration-300" data-id="element-151">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-brand-terracotta/20" data-id="element-152" />

              <div className="mb-6" data-id="element-153">
                <div className="flex text-brand-gold mb-2" data-id="element-154">{'★★★★★'}</div>
                <p className="font-sans text-brand-dark italic leading-relaxed" data-id="element-155">
                  "{testimonial.text}"
                </p>
              </div>

              <div className="flex items-center border-t border-brand-dark/10 pt-4" data-id="element-156">
                <div className="w-10 h-10 rounded-full bg-brand-sage/20 flex items-center justify-center text-brand-sage font-bold mr-3" data-id="element-157">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-158">
                  <p className="font-bold text-brand-dark text-sm" data-id="element-159">
                    {testimonial.name}, {testimonial.age}
                  </p>
                  <p className="text-xs text-brand-warm-gray" data-id="element-160">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}